import { Trial_Status, TrialInfoQuery } from '@generated/graphql';
import { createEvent, createStore } from 'effector';
import { AssessmentInfo, AssessmentPage, Question, QuestionFull } from 'store/assessment/types';

// События
export const setAssessmentInfo = createEvent<TrialInfoQuery['trialInfo']>();
export const setAssessmentStatus = createEvent<Trial_Status>();
export const nextPage = createEvent();
export const setPage = createEvent<AssessmentPage>();
export const nextQuestion = createEvent();
export const setQuestionIndex = createEvent<number>();
export const setCurrentQuestion = createEvent<QuestionFull>();
// Вставка текста в поле ответа (paste / drop), payload — длина вставленного текста
export const registerInsert = createEvent<number>();
export const resetAssessment = createEvent();
export const resetAnswerMetadata = createEvent();
export const setIsPublicExamination = createEvent<boolean>();
export const setAssessmentVisibilityStateChangeDetected = createEvent<boolean>();

// Стор для отключение обязательный проверок данный пользователя
export const $isPublicExamination = createStore<boolean>(false)
  .on(setIsPublicExamination, (_, value) => value)
  .reset(resetAssessment);

export const $questionIndex = createStore<number>(0)
  .on(nextQuestion, (index) => index + 1)
  .on(setQuestionIndex, (_, index) => index)
  .reset(resetAssessment);

// Стор со списком вопросов
export const $questions = createStore<Question[]>([])
  .on(setAssessmentInfo, (_, { questionList }) => {
    if (!questionList) return _;
    return questionList;
  })
  .reset(resetAssessment);

// Стор для текущей страницы тестирования
export const $assessmentPage = createStore<AssessmentPage>(AssessmentPage.Instructions)
  .on(nextPage, (currentPage) => {
    if (currentPage === AssessmentPage.Instructions) return AssessmentPage.Preview;
    if (currentPage === AssessmentPage.Preview) return AssessmentPage.Question;
    if (currentPage === AssessmentPage.Question) return AssessmentPage.Preview;
    return currentPage;
  })
  .on(setPage, (_, page) => page)
  .reset(resetAssessment);

// TODO: по идее, когда бэк добавит поле у себя, это значение нужно будет брать из $assessmentInfo и сохранять соответственно при отправке/пропуске/откладывании ответа на вопрос
export const $assessmentVisibilityStateChangeDetected = createStore<boolean>(false)
  .on(setAssessmentVisibilityStateChangeDetected, (_, value) => value)
  .reset(resetAssessment);

export const $assessmentStatus = createStore<Trial_Status | null>(null)
  .on(setAssessmentStatus, (_, status) => status)
  .reset(resetAssessment);

export const $assessmentInfo = createStore<AssessmentInfo | null>(null)
  .on(setAssessmentInfo, (_, trialInfo) => {
    if (!trialInfo) return null;
    const { questionList, ...rest } = trialInfo;
    return rest;
  })
  .reset(resetAssessment);

export const $currentQuestion = createStore<QuestionFull | null>(null)
  .on(setCurrentQuestion, (_, question) => question)
  .reset(resetAssessment);

export const $insertCount = createStore<number | 0>(0)
  .on(registerInsert, (count) => count + 1)
  .reset(resetAssessment)
  .reset(resetAnswerMetadata);

export const $insertSymbols = createStore<number | 0>(0)
  .on(registerInsert, (symbols, length) => symbols + length)
  .reset(resetAssessment)
  .reset(resetAnswerMetadata);
